import { R } from 'core/helpers'

const getNode = (elOrRef) => elOrRef?.current || elOrRef

const getNodes = (elements) => R.compact(R.map(elements, getNode))

export default getNodes
